import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class HttpLoggingInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      map((event) => {
        if (event instanceof HttpResponse) {
          this.log(req, event);
        }
        return event;
      })
    );
  }

  private log(req: HttpRequest<any>, resp: HttpResponse<any>): void {
    const requestWrapper = {
      request: {
        method: req.method,
        url: req.urlWithParams,
        headers: req.headers,
        body: req.body,
      },
      response: {
        status: resp.status,
        statusText: resp.statusText,
        headers: resp.headers,
        body: resp.body,
      },
    };
    console.debug(`HTTP Request - ${requestWrapper.request.method} ${requestWrapper.request.url}`, requestWrapper);
  }
}
